/**
 * Ramps Layout Route - Shared state and search parameter management
 *
 * This layout route ensures that all search parameters (country, state, amount, token, etc.)
 * are preserved across all child ramps routes during navigation.
 */

import { createFileRoute, Outlet } from "@tanstack/react-router";
import {
	type RampsSearchSchema,
	validateRampsSearch,
} from "../lib/ramps-search-schema";

function RampsLayout() {
	// This component just renders the child routes
	// The real value is in the validateSearch function below
	return <Outlet />;
}

export const Route = createFileRoute("/ramps")({
	validateSearch: validateRampsSearch,
	component: RampsLayout,
});

// Type export for use in child routes
export type { RampsSearchSchema };
